import store from "../store";

export const redirect = (to, from, next) => {
  if (store.state.auth.isAuth && store.state.session.session_token) {
    next({ path: "/" });
  } else {
    next();
  }
};
